import SvgCloseMEP from '@img/icons/close-mep.svg';
import SvgClose from '@img/icons/close.svg';
import SvgChevron from '@img/icons/menu-chevron-right.svg';
import LinkButton from '@stories/Components/Global/Buttons/LinkButton/LinkButton';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from '../DesktopNavigation.styles';
import FeaturedCard from '../FeaturedCard/FeaturedCard';
const NavigationDropdown = (props) => {
    const handleFirstHover = (id) => {
        if (id !== props.activeTwo) {
            props.onHoverFirst(id);
            props.onHoverSecond('');
        }
    };
    const handleSecondHover = (id) => props.onHoverSecond(id);
    /* Filter for only those links with a second column */
    const secondColumn = React.useMemo(() => props.children.filter((link) => link.children.length > 0), [props.children]);
    /* Filter for only those links with a third column */
    const thirdColumn = React.useMemo(() => secondColumn.length > 0
        ? secondColumn.filter((link) => link.children.filter((cl) => cl.children.length > 0).length > 0)
        : [], [secondColumn]);
    /* Determine how many columns will be used for links */
    const columnCount = thirdColumn.length > 0 ? 3 : secondColumn.length > 0 ? 2 : 1;
    /**
     * Ensure we only loop through as many featured cards as there is space for.
     * Eg. 3 cards if column count is 1, 2 cards if column count is 2, etc
     */
    const featuredColumn = props.featured && props.featured.length > 0
        ? props.featured.slice(0, Math.max(4 - columnCount, 1))
        : [];
    /* Use length of trimmed array to determine number of starting featured column */
    const featuredStart = 5 - featuredColumn.length;
    return (React.createElement(React.Fragment, null,
        React.createElement(S.DropdownBackground, { "data-active": props.active }),
        React.createElement(S.NavigationDropdown, { "data-active": props.active },
            React.createElement(S.NavigationDropdownInner, null,
                React.createElement(S.NavigationDropdownColumn, { "data-column": 1 }, props.children.map((cl) => (React.createElement("li", { key: cl.id },
                    React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                        React.createElement(S.DropdownNavigationLink, { id: `${cl.id}-main-link`, href: cl.url, target: cl.target, onMouseEnter: () => handleFirstHover(cl.children.length > 0 ? cl.id : ''), onFocus: () => handleFirstHover(cl.children.length > 0 ? cl.id : ''), onKeyDown: (event) => {
                                switch (event.key) {
                                    case 'ArrowRight':
                                        handleFirstHover(cl.children.length > 0 ? cl.id : '');
                                        if (cl.children.length > 0) {
                                            const getElement = document.getElementById(`${cl.id}-column`);
                                            if (getElement) {
                                                getElement?.querySelectorAll('a')?.[0].focus();
                                            }
                                        }
                                        break;
                                    case 'Escape':
                                        document.getElementById(`${props.id}-parent`)?.focus();
                                        props.onClose();
                                        break;
                                    default:
                                        break;
                                }
                            }, "data-active": cl.id === props.activeTwo, "data-has-children": cl.children.length > 0 },
                            props.site !== 'mep' ? React.createElement(SvgChevron, null) : null,
                            cl.text)))))),
                secondColumn.length > 0
                    ? secondColumn.map((link) => (React.createElement(S.NavigationDropdownColumn, { key: `${link.id}-column`, id: `${link.id}-column`, "data-column": 2, "data-active": link.id === props.activeTwo },
                        React.createElement("li", null,
                            React.createElement(LinkButton, { buttonType: "link", href: link.url, target: link.target, onMouseEnter: () => handleSecondHover(''), onFocus: () => handleSecondHover(''), site: props.site, tabIndex: link.id === props.activeTwo ? 0 : -1, onKeyDown: (event) => {
                                    switch (event.key) {
                                        case 'ArrowLeft':
                                        case 'Escape':
                                            document.getElementById(`${link.id}-main-link`)?.focus();
                                            handleFirstHover('');
                                            break;
                                        default:
                                            break;
                                    }
                                } },
                                "View All",
                                props.site !== 'mep' ? ` ${link.text}` : ``)),
                        link.children.map((cl) => (React.createElement("li", { key: cl.id },
                            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                React.createElement(S.DropdownNavigationLink, { id: `${cl.id}-main-link`, href: cl.url, target: cl.target, onMouseEnter: () => handleSecondHover(cl.children.length > 0 ? cl.id : ''), onFocus: () => handleSecondHover(cl.children.length > 0 ? cl.id : ''), onKeyDown: (event) => {
                                        switch (event.key) {
                                            case 'ArrowRight':
                                                handleSecondHover(cl.children.length > 0 ? cl.id : '');
                                                if (cl.children.length > 0) {
                                                    const getElement = document.getElementById(`${cl.id}-column`);
                                                    if (getElement) {
                                                        getElement?.querySelectorAll('a')?.[0].focus();
                                                    }
                                                }
                                                break;
                                            case 'ArrowLeft':
                                            case 'Escape':
                                                document.getElementById(`${link.id}-main-link`)?.focus();
                                                handleFirstHover('');
                                                break;
                                            default:
                                                break;
                                        }
                                    }, "data-active": cl.id === props.activeThree, tabIndex: link.id === props.activeTwo ? 0 : -1 }, cl.text))))))))
                    : null,
                thirdColumn.length > 0
                    ? thirdColumn.map((top) => (React.createElement(React.Fragment, { key: `${top.id}-column-wrapper` }, top.children.map((link) => (React.createElement(React.Fragment, { key: `${link.id}-column` }, link.children.length > 0 ? (React.createElement(S.NavigationDropdownColumn, { key: `${link.id}-column`, id: `${link.id}-column`, "data-column": 3, "data-active": link.id === props.activeThree },
                        React.createElement("li", null,
                            React.createElement(LinkButton, { buttonType: "link", href: link.url, target: link.target, site: props.site, tabIndex: link.id === props.activeThree ? 0 : -1, onKeyDown: (event) => {
                                    switch (event.key) {
                                        case 'ArrowLeft':
                                        case 'Escape':
                                            document.getElementById(`${link.id}-main-link`)?.focus();
                                            handleSecondHover('');
                                            break;
                                        default:
                                            break;
                                    }
                                } }, "View All")),
                        link.children.map((cl) => (React.createElement("li", { key: cl.id },
                            React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                                React.createElement(S.DropdownNavigationLink, { href: cl.url, target: cl.target, tabIndex: link.id === props.activeThree ? 0 : -1, onKeyDown: (event) => {
                                        switch (event.key) {
                                            case 'ArrowLeft':
                                            case 'Escape':
                                                document.getElementById(`${link.id}-main-link`)?.focus();
                                                handleSecondHover('');
                                                break;
                                            default:
                                                break;
                                        }
                                    } }, cl.text))))))) : null))))))
                    : null,
                featuredColumn.map((card, i) => (React.createElement(S.NavigationDropdownColumn, { key: card.id, "data-featured": true, "data-column": featuredStart + i },
                    React.createElement("li", null,
                        React.createElement(FeaturedCard, { ...card, site: props.site }))))),
                React.createElement(FocusRing, { focusRingClass: "focus-ring" },
                    React.createElement(S.CloseButton, { "aria-label": `Close ${props.text} dropdown`, onClick: props.onClose }, props.site === 'mep' ? React.createElement(SvgCloseMEP, null) : React.createElement(SvgClose, null)))))));
};
export default NavigationDropdown;
